import { render, staticRenderFns } from "./ActionCenterDismissedView.vue?vue&type=template&id=7f993bae&"
import script from "./ActionCenterDismissedView.vue?vue&type=script&lang=js&"
export * from "./ActionCenterDismissedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports